import { createAction, handleActions } from "redux-actions";

const CHANGE_NAME = "specialCheck/CHANGE_NAME";
const CHANGE_PHONE_NO = "specialCheck/CHANGE_PHONE_NO";
export const changeName = createAction(CHANGE_NAME, (name) => name);
export const changePhone = createAction(CHANGE_PHONE_NO, (phone) => phone);
// export const changeName = (name) => ({
//   type: CHANGE_NAME,
//   name,
// });
// export const changePhone = (phone) => ({
//   type: CHANGE_PHONE_NO,
//   phone,
// });
const initialState = {
  name: "",
  phone: "",
};
const specialCheck = handleActions(
  {
    [CHANGE_NAME]: (state, { payload: name }) => ({
      ...state,
      name,
    }),
    [CHANGE_PHONE_NO]: (state, { payload: phone }) => ({
      ...state,
      phone,
    }),
  },
  initialState
);
export default specialCheck;
// export default function specialCheck(state = initialState, action) {
//   switch (action.type) {
//     case CHANGE_NAME:
//       return { ...state, name: action.name };
//     case CHANGE_PHONE_NO:
//       return { ...state, phone: action.phone };
//     default:
//       return state;
//   }
// }
